
import { defineComponent } from "vue";
import WarningIcon from "@/components/icons/WarningIcon.vue";
import SelectByVin from "@/cars/SelectByVin.vue";
import SelectByType from "@/cars/SelectByType.vue";
import { Car } from "@/cars/types";
import { mapActions, mapGetters } from "vuex";
import AdditionalInfo from "@/cars/AdditionalInfo.vue";

interface SelectingCarData {
  hasNotVin: Boolean;
  wantSelectCar: Boolean;
}

export default defineComponent({
  props: {
    isAddingNext: Boolean,
  },
  data(): SelectingCarData {
    return {
      hasNotVin: true,
      wantSelectCar: false,
    };
  },
  methods: {
    ...mapActions("cars", ["createCar", "saveTmpCar"]),
    toggleVinSelect() {
      this.hasNotVin = !this.hasNotVin;
    },
    selectionFinished(car: Car) {
      if (this.user) {
        this.createCar(car);
        this.hasNotVin = true;
        this.$emit("selectionFinished");
      } else {
        this.saveTmpCar(car);
        this.$emit("needRegistration");
      }
    },
  },
  computed: {
    ...mapGetters("accounts", ["user"]),
  },
  components: {
    AdditionalInfo,
    SelectByVin,
    SelectByType,
  },
});
